import { useState } from "react";

// Blog Section - Restaurants Recommendations
const BlogSection = () => {
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  const restaurants = [
    {
      id: 1,
      name: "Los Robles de León",
      type: "Cocina Mediterránea Tradicional",
      description: "Exquisita cocina tradicional mediterránea en pleno corazón de Málaga. Especialidad en carnes a la brasa, cochinillo y cordero lechal de Burgos.",
      image: "https://customer-assets.emergentagent.com/job_b5bd5f4a-d504-46bf-ad61-768b78dda5bc/artifacts/woxaqyyu_WhatsApp%20Image%202026-05-23%20at%2005.47.31.jpeg",
      address: "Avenida Luis Buñuel, 7, 29009 Málaga",
      phone: "+34 952 28 36 62",
      email: "info@restaurantelosrobles.es",
      website: "https://www.restaurantelosrobles.es",
      hours: {
        winter: "Martes a Domingo: 13:00-17:00 | Viernes y Sábados: 20:00-24:00 | Lunes cerrado",
        summer: "Lunes a Sábados: 13:00-17:00 | Viernes y Sábados: 20:00-24:00 | Domingos cerrado"
      },
      features: ["Salones privados", "Horno de leña", "Carnes a la brasa", "Mariscos"],
      rating: "4.8",
      mapUrl: "https://maps.google.com/?q=Avenida+Luis+Buñuel+7+Málaga"
    },
    {
      id: 2,
      name: "Silencio Beach Club",
      type: "Beach Club & Restaurante",
      description: "Un lugar único donde la buena música, los sabores irresistibles y la magia del mar se encuentran. Relájate con vistas espectaculares, disfruta de cócteles frescos y deja que los ritmos vibrantes te envuelvan.",
      image: "https://silencioclub.com/wp-content/uploads/2024/12/MlevSLon-scaled.webp",
      address: "P.º Marítimo Torremolinos, 20, 29620 Torremolinos, Málaga",
      phone: "+34 664 233 464",
      email: "",
      website: "http://silencioclub.com/es/",
      hours: {
        winter: "Consultar disponibilidad en web",
        summer: "Temporada de hamacas y camas balinesas"
      },
      features: ["Beach Club", "Restaurante", "Cócteles", "Eventos", "Hamacas", "Camas Balinesas"],
      rating: "4.7",
      mapUrl: "https://www.google.com/maps/place/P.%C2%BA+Mar%C3%ADtimo+Torremolinos,+20,+29620+Torremolinos,+M%C3%A1laga"
    }
  ];

  return (
    <section id="recomendaciones" className="py-16 sm:py-24 px-4" data-testid="blog-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <p className="section-subtitle">
            <i className="fas fa-utensils mr-2"></i>
            Recomendaciones
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: "'Cinzel', serif" }}>
            Descubre la <span className="gradient-text">Costa del Sol</span>
          </h2>
          <p className="text-gray-400 mt-4">
            Los mejores restaurantes donde comer durante tu visita. ¡Te llevamos!
          </p>
        </div>

        {/* Restaurant Cards */}
        <div className="grid gap-6">
          {restaurants.map((restaurant) => (
            <div 
              key={restaurant.id}
              className="glass rounded-2xl overflow-hidden cursor-pointer hover:border-[#c9a962]/50 border border-transparent transition-all"
              onClick={() => setSelectedRestaurant(selectedRestaurant === restaurant.id ? null : restaurant.id)}
            >
              <div className="flex flex-col md:flex-row">
                {/* Image */}
                <div className="md:w-1/3 h-48 md:h-auto relative">
                  <img 
                    src={restaurant.image} 
                    alt={restaurant.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-3 left-3 bg-[#c9a962] text-[#1a1a2e] px-3 py-1 rounded-full text-sm font-bold">
                    <i className="fas fa-star mr-1"></i>{restaurant.rating}
                  </div>
                </div>
                
                {/* Content */}
                <div className="md:w-2/3 p-6">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <h3 className="text-xl sm:text-2xl font-bold text-white mb-1 notranslate" style={{ fontFamily: "'Cinzel', serif" }}>
                        {restaurant.name}
                      </h3>
                      <p className="text-[#c9a962] text-sm">{restaurant.type}</p>
                    </div>
                    <i className={`fas fa-chevron-${selectedRestaurant === restaurant.id ? 'up' : 'down'} text-[#c9a962] transition-transform`}></i>
                  </div>
                  <p className="text-gray-400 mb-4">{restaurant.description}</p>
                  
                  {/* Features */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {restaurant.features.map((feature, idx) => (
                      <span key={idx} className="bg-[#1e1e32] text-gray-300 px-3 py-1 rounded-full text-xs">
                        {feature}
                      </span>
                    ))}
                  </div>
                  
                  <p className="text-sm text-gray-500">
                    <i className="fas fa-hand-pointer mr-2 text-[#c9a962]"></i>
                    Haz clic para ver información de contacto y reservas
                  </p>
                </div>
              </div>

              {/* Expanded Details */}
              {selectedRestaurant === restaurant.id && (
                <div className="border-t border-[#2a2a45] p-6 bg-[#0a0a14] animate-fade-in">
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {/* Address */}
                    <div>
                      <h4 className="text-[#c9a962] font-semibold mb-2 flex items-center gap-2">
                        <i className="fas fa-map-marker-alt"></i> Dirección
                      </h4>
                      <p className="text-gray-300 text-sm">{restaurant.address}</p>
                      <a 
                        href={restaurant.mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-[#c9a962] text-sm mt-2 hover:underline"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <i className="fas fa-directions"></i> Ver en Google Maps
                      </a>
                    </div>
                    
                    {/* Contact */}
                    <div>
                      <h4 className="text-[#c9a962] font-semibold mb-2 flex items-center gap-2">
                        <i className="fas fa-phone"></i> Contacto y Reservas
                      </h4>
                      <a href={`tel:${restaurant.phone}`} className="block text-white text-lg font-semibold hover:text-[#c9a962]" onClick={(e) => e.stopPropagation()}>
                        {restaurant.phone}
                      </a>
                      {restaurant.email && (
                        <a href={`mailto:${restaurant.email}`} className="block text-gray-400 text-sm hover:text-[#c9a962] mt-1" onClick={(e) => e.stopPropagation()}>
                          {restaurant.email}
                        </a>
                      )}
                      <a 
                        href={restaurant.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-[#c9a962] text-sm mt-2 hover:underline"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <i className="fas fa-globe"></i> Visitar web
                      </a>
                    </div>
                    
                    {/* Hours */}
                    <div>
                      <h4 className="text-[#c9a962] font-semibold mb-2 flex items-center gap-2">
                        <i className="fas fa-clock"></i> Horario
                      </h4>
                      <p className="text-gray-300 text-sm mb-1"><strong>Invierno:</strong></p>
                      <p className="text-gray-400 text-xs mb-2">{restaurant.hours.winter}</p>
                      <p className="text-gray-300 text-sm mb-1"><strong>Verano:</strong></p>
                      <p className="text-gray-400 text-xs">{restaurant.hours.summer}</p>
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="mt-6 pt-6 border-t border-[#2a2a45] text-center">
                    <p className="text-gray-400 mb-4">
                      <i className="fas fa-car text-[#c9a962] mr-2"></i>
                      ¿Necesitas transfer al restaurante? <strong className="text-white">¡Te llevamos!</strong>
                    </p>
                    <a
                      href={`https://wa.me/34600221794?text=Hola,%20necesito%20un%20transfer%20al%20restaurante%20${encodeURIComponent(restaurant.name)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-3 px-6 rounded-lg transition-all"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className="fab fa-whatsapp text-xl"></i>
                      Reservar Transfer al Restaurante
                    </a>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
